var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* eslint-disable react-hooks/exhaustive-deps */
import { Center, Text, Box, Flex, FormControl, FormLabel, Input, HStack, Button, Divider, Select, useToast, FormErrorMessage, Spinner, VStack, Switch, } from "@reverb-ui/react";
import { Lock } from "@reverb-ui/icons-react";
import React, { useEffect, useMemo, useState } from "react";
import { useContext } from "react";
import { AuthContext } from "@/shared/presentation/context-api/providers/auth";
import { EntityContext } from "@/shared/presentation/context-api/providers/entity";
import { UtilContext } from "@/shared/presentation/context-api/providers/util";
import { useForm, Controller, useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import OtpQrCodeModal from "@/features/my-account/containers/profile/otp-qrcode-modal";
import OtpInputModal from "@/features/my-account/containers/profile/otp-input-modal";
import { GtnContext } from "@/shared/presentation/context-api/providers/gtn";
import { RequiredIndicator } from "@/features/first-access/presentation/components/required-indicator";
export var ProfileContainer = function () {
    var _a;
    var t = useTranslation("my-account").t;
    var _b = useContext(AuthContext), makeChangePassword = _b.changePassword, logOut = _b.logOut, generateQrCode = _b.generateQrCode, toggleTfa = _b.toggleTfa, recoverTfaPin = _b.recoverTfaPin, validateTfaToken = _b.validateTfaToken, clientWallets = _b.clientWallets, renewToken = _b.renewToken;
    var clientWalletId = (_a = clientWallets === null || clientWallets === void 0 ? void 0 : clientWallets[0]) === null || _a === void 0 ? void 0 : _a.walletUuid;
    var _c = useContext(UtilContext), countries = _c.countries, documentTypes = _c.documentTypes;
    var _d = useContext(EntityContext), name = _d.name, country = _d.country, documentType = _d.documentType, documentNumber = _d.document, email = _d.email, makeUpdateUser = _d.makeUpdateUser, loading = _d.loading, is2faEnabled = _d.is2faEnabled, refreshEntityData = _d.refreshEntityData, jobDescription = _d.jobDescription, preferredName = _d.preferredName;
    var gtnProfile = useContext(GtnContext).profile;
    var _e = useForm(), register = _e.register, control = _e.control, setValue = _e.setValue, handleSubmit = _e.handleSubmit;
    var toast = useToast();
    var _f = useState(""), password = _f[0], setPassword = _f[1];
    var _g = useState(), changePasswordError = _g[0], setChangePasswordError = _g[1];
    var _h = useState(false), tfaModalIsOpen = _h[0], setTfaModalIsOpen = _h[1];
    var _j = useState(false), otpModalIsOpen = _j[0], setOtpModalIsOpen = _j[1];
    var _k = useState(), otpModalMode = _k[0], setOtpModalMode = _k[1];
    var _l = useState(false), loadingUpdateUser = _l[0], setLoadingUpdateUser = _l[1];
    var formValues = useWatch({ control: control });
    var gtnProfileCountry = useMemo(function () {
        var _a, _b, _c;
        var countryName = (_c = (_b = (_a = gtnProfile === null || gtnProfile === void 0 ? void 0 : gtnProfile.personalInformation) === null || _a === void 0 ? void 0 : _a.location) === null || _b === void 0 ? void 0 : _b.split(", ")) === null || _c === void 0 ? void 0 : _c[1];
        if (!countryName)
            return;
        return countries === null || countries === void 0 ? void 0 : countries.find(function (_a) {
            var description = _a.description;
            return description === countryName;
        });
    }, [gtnProfile, countries]);
    var _m = useWatch({ control: control }), selectedCountry = _m.locationId, selectedDocumentType = _m.documentType;
    var filteredDocumentTypes = useMemo(function () {
        if ((selectedCountry === null || selectedCountry === void 0 ? void 0 : selectedCountry.label) === "Brazil")
            return documentTypes;
        return documentTypes.filter(function (_a) {
            var description = _a.description;
            return description !== "CNPJ" && description !== "CPF";
        });
    }, [documentTypes, selectedCountry]);
    useEffect(function () {
        if ((selectedCountry === null || selectedCountry === void 0 ? void 0 : selectedCountry.label) &&
            (selectedCountry === null || selectedCountry === void 0 ? void 0 : selectedCountry.label) !== "Brazil" &&
            ((selectedDocumentType === null || selectedDocumentType === void 0 ? void 0 : selectedDocumentType.label) === "CNPJ" ||
                (selectedDocumentType === null || selectedDocumentType === void 0 ? void 0 : selectedDocumentType.label) === "CPF")) {
            setValue("documentType", undefined);
        }
    }, [selectedCountry]);
    useEffect(function () {
        setValue("name", name);
        setValue("locationId", {
            value: (country === null || country === void 0 ? void 0 : country.id) || (gtnProfileCountry === null || gtnProfileCountry === void 0 ? void 0 : gtnProfileCountry.id),
            label: (country === null || country === void 0 ? void 0 : country.description) || (gtnProfileCountry === null || gtnProfileCountry === void 0 ? void 0 : gtnProfileCountry.description),
        });
        setValue("documentType", {
            value: documentType === null || documentType === void 0 ? void 0 : documentType.id,
            label: documentType === null || documentType === void 0 ? void 0 : documentType.description,
        });
        setValue("document", documentNumber);
        setValue("email", email);
    }, [name, country, documentType, documentNumber, email, gtnProfileCountry]);
    useEffect(function () {
        setValue("preferredName", preferredName);
        if (preferredName) {
            setValue("usePreferredName", true);
        }
        if (clientWalletId) {
            setValue("jobDescription", jobDescription);
        }
    }, [preferredName, jobDescription, clientWalletId]);
    var updateUser = function (values) { return __awaiter(void 0, void 0, void 0, function () {
        var email, document, name, documentType, locationId, usePreferredName, preferredName, jobDescription, isEmailUpdated, body, title;
        return __generator(this, function (_a) {
            email = values.email, document = values.document, name = values.name, documentType = values.documentType, locationId = values.locationId, usePreferredName = values.usePreferredName, preferredName = values.preferredName, jobDescription = values.jobDescription;
            isEmailUpdated = values.email !== email;
            body = {
                email: email,
                document: document,
                name: name,
                documentTypeId: documentType.value,
                locationId: locationId.value,
                preferredName: getPreferredName(usePreferredName, preferredName),
                jobDescription: jobDescription || null,
            };
            title = isEmailUpdated
                ? "Your email was updated, you'll have to login again to apply the changes"
                : "Data updated successfully";
            setLoadingUpdateUser(true);
            makeUpdateUser(body)
                .then(function () {
                toast({
                    title: title,
                    status: "success",
                    duration: 5000,
                    isClosable: true,
                    onCloseComplete: function () {
                        if (!isEmailUpdated) {
                            renewToken();
                            return;
                        }
                        logOut(function () { });
                    },
                });
            })
                .catch(function (e) {
                toast({
                    title: e.message || "Something went wrong",
                    status: "error",
                    duration: 5000,
                    isClosable: true,
                });
            })
                .finally(function () { return setLoadingUpdateUser(false); });
            return [2 /*return*/];
        });
    }); };
    var getPreferredName = function (usePreferredName, preferredName) {
        if (!usePreferredName) {
            return null;
        }
        return preferredName;
    };
    var changePassword = function () {
        makeChangePassword(password)
            .then(function () {
            setChangePasswordError(null);
            toast({
                title: "Password updated successfully",
                status: "success",
                duration: 5000,
                isClosable: true,
            });
        })
            .catch(setChangePasswordError);
    };
    var enableTfa = function (otp) { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 4, , 5]);
                    return [4 /*yield*/, validateTfaToken(otp)];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, toggleTfa()];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, refreshEntityData()];
                case 3:
                    _a.sent();
                    setOtpModalIsOpen(false);
                    toast({
                        title: "Two-factor authentication enabled",
                        description: "We recommend to keep this feature active",
                        status: "success",
                        duration: 5000,
                        isClosable: true,
                    });
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _a.sent();
                    toast({
                        title: "Wrong one-time password informed",
                        description: "Check your Google Authenticator app and try again",
                        status: "error",
                        duration: 5000,
                        isClosable: true,
                    });
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var disableTfa = function (otp) { return __awaiter(void 0, void 0, void 0, function () {
        var error_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 4, , 5]);
                    return [4 /*yield*/, validateTfaToken(otp)];
                case 1:
                    _a.sent();
                    return [4 /*yield*/, toggleTfa()];
                case 2:
                    _a.sent();
                    return [4 /*yield*/, refreshEntityData()];
                case 3:
                    _a.sent();
                    setOtpModalIsOpen(false);
                    toast({
                        title: "Two-factor authentication disabled",
                        description: "We recommend to keep this feature active",
                        status: "success",
                        duration: 5000,
                        isClosable: true,
                    });
                    return [3 /*break*/, 5];
                case 4:
                    error_2 = _a.sent();
                    toast({
                        title: "Wrong one-time password informed",
                        description: "Check your Google Authenticator app and try again",
                        status: "error",
                        duration: 5000,
                        isClosable: true,
                    });
                    return [3 /*break*/, 5];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var recoverPin = function () {
        recoverTfaPin(email).then(function () {
            toast({
                title: "Recovery email sent!",
                description: "Check your email and scan the new QR Code to recover your access to Rock Content",
                status: "success",
                duration: 5000,
                isClosable: true,
            });
        });
    };
    useEffect(function () {
        var inputs = document.querySelectorAll("input");
        inputs.forEach(function (input) {
            input.setAttribute("aria-autocomplete", "none");
            input.setAttribute("autocomplete", "off");
        });
    }, [loading]);
    return (React.createElement(Box, { bg: "white", w: "full" },
        loading && (React.createElement(Center, { py: "20" },
            React.createElement(Spinner, { color: "blue.500" }))),
        !loading && (React.createElement(Box, { p: "2", px: "6", pt: "0" },
            React.createElement("form", { onSubmit: handleSubmit(updateUser), autoComplete: "off" },
                React.createElement(HStack, { pt: "6", gridGap: "4" },
                    React.createElement(FormControl, { isRequired: true },
                        React.createElement(FormLabel, { fontSize: "sm", color: "gray.800", requiredIndicator: React.createElement(RequiredIndicator, null) }, t("profile-tab.name")),
                        React.createElement(Input, __assign({ autoComplete: "off", name: "name" }, register("name")))),
                    React.createElement(FormControl, { isRequired: true },
                        React.createElement(FormLabel, { fontSize: "sm", color: "gray.800" }, t("profile-tab.e-mail")),
                        React.createElement(Input, __assign({ autoComplete: "off", name: "email", isDisabled: true }, register("email"))))),
                React.createElement(HStack, { pt: "6", gridGap: "4" },
                    React.createElement(FormControl, { display: "flex", alignItems: "center" },
                        React.createElement(FormLabel, { fontSize: "sm", color: "gray.800" }, t("profile-tab.uses-preferred-name")),
                        React.createElement(Switch, __assign({}, register("usePreferredName")))),
                    formValues.usePreferredName && (React.createElement(FormControl, { isRequired: true },
                        React.createElement(FormLabel, { requiredIndicator: React.createElement(RequiredIndicator, null), fontSize: "sm" }, t("profile-tab.preferred-name")),
                        React.createElement(Input, __assign({}, register("preferredName")))))),
                !clientWalletId && (React.createElement(HStack, { pt: "6", spacing: "4" },
                    React.createElement(FormControl, { flex: 1 },
                        React.createElement(FormLabel, { fontSize: "sm", color: "gray.800" }, t("profile-tab.document-type")),
                        React.createElement(Controller, { control: control, name: "documentType", render: function (_a) {
                                var _b = _a.field, onChange = _b.onChange, onBlur = _b.onBlur, value = _b.value, name = _b.name, ref = _b.ref;
                                return (React.createElement(Select, { inputProps: {
                                        autoComplete: "cc-document-type",
                                        autoCorrect: "off",
                                        spellCheck: "off",
                                    }, onBlur: onBlur, onChange: onChange, name: name, value: value, ref: ref, options: filteredDocumentTypes.map(function (_a) {
                                        var id = _a.id, description = _a.description;
                                        return ({
                                            value: id,
                                            label: description,
                                        });
                                    }) }));
                            } })),
                    React.createElement(FormControl, { flex: 1 },
                        React.createElement(FormLabel, { fontSize: "sm", color: "gray.800" }, t("profile-tab.document-number")),
                        React.createElement(Input, __assign({ autoComplete: "off", name: "document", isDisabled: true }, register("document")))))),
                React.createElement(HStack, { pt: "6", gridGap: "4" },
                    clientWalletId && (React.createElement(FormControl, { flex: 1 },
                        React.createElement(FormLabel, { fontSize: "sm", color: "gray.800" }, t("profile-tab.job-description")),
                        React.createElement(Input, __assign({}, register("jobDescription"))))),
                    React.createElement(FormControl, { flex: 1 },
                        React.createElement(FormLabel, { fontSize: "sm", color: "gray.800" }, t("profile-tab.country")),
                        React.createElement(Controller, { control: control, name: "locationId", render: function (_a) {
                                var _b = _a.field, onChange = _b.onChange, onBlur = _b.onBlur, value = _b.value, name = _b.name, ref = _b.ref;
                                return (React.createElement(Select, { inputProps: {
                                        autoComplete: "nope",
                                        autoCorrect: "off",
                                        spellCheck: "off",
                                    }, onBlur: onBlur, onChange: onChange, name: "locationId", value: value, ref: ref, options: countries.map(function (_a) {
                                        var id = _a.id, description = _a.description;
                                        return ({
                                            value: id,
                                            label: description,
                                        });
                                    }) }));
                            } })),
                    !clientWalletId && React.createElement(Box, { flex: 1 })),
                React.createElement(Divider, { mt: "6" }),
                React.createElement(VStack, { w: "full", alignItems: "start" },
                    React.createElement("form", { style: { width: "100%" } },
                        React.createElement(Flex, { alignItems: "center", pt: "6" },
                            React.createElement(Lock, { color: "gray.400" }),
                            React.createElement(Text, { ml: "3", fontWeight: "800" }, t("profile-tab.security"))),
                        React.createElement(HStack, { pt: "6", gridGap: "4", w: "full", alignItems: "flex-end" },
                            React.createElement(FormControl, { flex: "1", isInvalid: !!(changePasswordError === null || changePasswordError === void 0 ? void 0 : changePasswordError.message) },
                                React.createElement(FormLabel, { fontSize: "sm", color: "gray.800" }, t("profile-tab.password")),
                                React.createElement(Input, { autoComplete: "off", type: "password", name: "password", value: password, placeholder: "********", onChange: function (e) { return setPassword(e.target.value); } }),
                                React.createElement(FormErrorMessage, { fontSize: "xs" }, changePasswordError === null || changePasswordError === void 0 ? void 0 : changePasswordError.message)),
                            React.createElement(Box, { flex: "1" },
                                React.createElement(Button, { variant: "outline", onClick: changePassword }, t("profile-tab.change-password")))),
                        React.createElement(HStack, { pt: "6", gridGap: "4", alignItems: "flex-end" },
                            React.createElement(Box, null,
                                is2faEnabled && (React.createElement(Button, { variant: "solid", onClick: function () {
                                        setOtpModalMode("disableTfa");
                                        setOtpModalIsOpen(true);
                                    } }, t("profile-tab.disable-tfa"))),
                                false && (React.createElement(Button, { variant: "solid", onClick: function () { return setTfaModalIsOpen(true); } }, t("profile-tab.enable-tfa")))),
                            is2faEnabled && (React.createElement(Box, null,
                                React.createElement(Button, { variant: "outline", onClick: recoverPin }, t("profile-tab.recover-tfa"))))))),
                React.createElement(Flex, { w: "100%", justifyContent: "flex-end", pt: "6" },
                    React.createElement(HStack, { gridGap: "3" },
                        React.createElement(Button, { variant: "outline" }, "Cancel"),
                        React.createElement(Button, { colorScheme: "blue", bg: "blue.500", type: "submit", isDisabled: !!loadingUpdateUser }, t("profile-tab.save-changes"))))))),
        React.createElement(OtpQrCodeModal, { generateQrCode: generateQrCode, isOpen: tfaModalIsOpen, onClose: function () { return setTfaModalIsOpen(false); }, onSubmit: function () { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    setOtpModalMode("enableTfa");
                    setTfaModalIsOpen(false);
                    setOtpModalIsOpen(true);
                    return [2 /*return*/];
                });
            }); } }),
        React.createElement(OtpInputModal, { isOpen: otpModalIsOpen, onClose: function () { return setOtpModalIsOpen(false); }, onCancel: function () {
                if (otpModalMode === "enableTfa") {
                    setTfaModalIsOpen(true);
                    setOtpModalIsOpen(false);
                    setOtpModalMode(null);
                }
                else if (otpModalMode === "disableTfa")
                    setOtpModalIsOpen(false);
            }, otpModalMode: otpModalMode, onSubmit: function (otp) { return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    if (otpModalMode === "enableTfa")
                        enableTfa(otp);
                    else if (otpModalMode === "disableTfa")
                        disableTfa(otp);
                    return [2 /*return*/];
                });
            }); }, onRecoverPin: recoverPin })));
};
